import { render, staticRenderFns } from "./MenuCombo.vue?vue&type=template&id=1f33e611&"
import script from "./MenuCombo.vue?vue&type=script&lang=js&"
export * from "./MenuCombo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports